import { Button } from '@recipes/ui';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { AdminPage } from '@/features/admin/admin-layout';

/** Where the help lives: one file in the repository (docs/admin-help.html), copied by the build. */
export const ADMIN_HELP_URL = '/admin-help.html';

/**
 * The administrator's help – what to set on the server (push keys, mail, AI …) and what to do
 * when something does not work. Written once as plain HTML in the repository, shown here as it
 * is, so that it can be read without the app as well.
 */
export function AdminHelpPage() {
  const { t } = useTranslation();
  return (
    <AdminPage
      section="help"
      description={t('admin.help.description')}
      actions={
        <Button asChild variant="outline">
          <a href={ADMIN_HELP_URL} target="_blank" rel="noreferrer" data-testid="admin-help-open">
            <ExternalLink aria-hidden /> {t('admin.help.openTab')}
          </a>
        </Button>
      }
    >
      <iframe
        src={ADMIN_HELP_URL}
        title={t('admin.sections.help')}
        className="h-[75vh] w-full rounded-lg border bg-card"
        data-testid="admin-help-frame"
      />
    </AdminPage>
  );
}
